import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  position: relative;
  z-index: 1;
  max-width: 420px;
  padding: 0 0 96px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--dark-slate);

  a {
    font-weight: 500;
    color: var(--slate);

    &:hover {
      color: var(--green);
    }
  }
`;

const Footer = () => (
  <StyledFooter>
    <p>
      Loosely designed after{' '}
      <a href="https://brittanychiang.com/" target="_blank" rel="noreferrer">
        Brittany Chiang
      </a>
      . Built with Gatsby and styled-components. All text is set in the Inter typeface.
    </p>
  </StyledFooter>
);

export default Footer;
